import CopyButton from "@components/CopyButton/CopyButton"
import { toCurrencyFormat } from "@lib/utils"
import { WHITE } from "@styles/colors"
import {
    Container,
    ContentContainer,
    AmountLabel,
    AmountContainer,
    AmountValue,
    CopyButtonContainer,
    JIDRCardBackground
} from "./JIDRContainerDisplay.styles"
import { JIDRCurrency } from "@components/CurrencyIcon/CurrencyIcon"
import { useTranslation } from "react-i18next"

const JIDRContainerDisplay = ({
    label,
    amount
}: {
    label?: string
    amount: number
}) => {
    const { t } = useTranslation();
    const displayLabel = label || t('components.jidrContainerDisplay.defaultLabel');
    return (
        <div>
            <Container>
                <ContentContainer>
                    <AmountLabel>{displayLabel}</AmountLabel>
                    <AmountContainer>
                        <JIDRCurrency />
                        <AmountValue>
                            {toCurrencyFormat(amount)}
                        </AmountValue>
                    </AmountContainer>
                </ContentContainer>
                <CopyButtonContainer>
                    <CopyButton 
                        onClick={() => {}} 
                        stringToCopy={amount.toString()} 
                        color={WHITE} 
                        backgroundColor="#FFFFFF33" 
                    />
                </CopyButtonContainer>
                <JIDRCardBackground />
            </Container>
        </div>
    )
}

export default JIDRContainerDisplay